/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardComplianceControlHealth {
    getFixupPrototypeFunction() { return SecurityDashboardComplianceControlHealth.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardComplianceControlHealth>): SecurityDashboardComplianceControlHealth {
        let obj = Object.assign(new SecurityDashboardComplianceControlHealth(), model);
        SecurityDashboardComplianceControlHealth.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardComplianceControlHealth>): SecurityDashboardComplianceControlHealth {
        if (!model) return null;
        return SecurityDashboardComplianceControlHealth.newInstance(<SecurityDashboardComplianceControlHealth> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardComplianceControlHealth) {
        if (!obj) return;

        models.SecurityDashboardComplianceControlHealth.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardComplianceControlHealth): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardComplianceControlHealth.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.trend) {
            for (let val of this.trend) {
                models.SecurityDashboardComplianceControlHealthTrend.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of Compliance Control Family
     */
    control_family: string;

    trend: Array<models.SecurityDashboardComplianceControlHealthTrend>;

}
